<section class="pt-4 px-6">
  <a [routerLink]="url()">
    <lib-brand-logo></lib-brand-logo>
  </a>
</section>
